import { DealIconComponent } from '../assets/icons/deal';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'payment_deals',
  label: 'Planos de pagamento',
  icon: DealIconComponent()
};

export default generateResources(resource);
